import { css } from '@emotion/react'
import { theme } from 'styles/theme/hav-theme'

export const borderBlur = css`
  border: ${theme.shapes.borderWidth.thin} ${theme.colors.neutral[40]};
  box-shadow: none;
`

export const borderFocused = css`
  border: ${theme.shapes.borderWidth.sm} ${theme.colors.neutral.medium};
  box-shadow: 0px 0px 2px 1px ${theme.colors.primary.main}50;
`

export const inputBorderCss = css`
  border-radius: ${theme.shapes.borderRadius.sm};
  ${borderBlur};

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0 100vw ${theme.colors.neutral.white} inset !important;
    box-shadow: 0 0 0 100vw ${theme.colors.neutral.white} inset !important;
  }

  :focus-within,
  &.Mui-focused {
    ${borderFocused}
  }

  &.Mui-disabled {
    * {
      cursor: not-allowed;
    }
    background-color: ${theme.colors.neutral[100]};
    fieldset {
      border: none;
      box-shadow: none;
    }
  }

  input.Mui-disabled {
    background-color: transparent;
  }
`

export const inputTextCss = css`
  font-size: ${theme.typography.sizes['2xs']};
  font-weight: ${theme.typography.weight.xsm};
  color: ${theme.colors.neutral[80]};
  line-height: ${theme.typography.lineHeight.sm};
  background-color: transparent !important;
`

export const baseInputStyles = css`
  ${inputBorderCss};

  fieldset {
    border: none;
    box-shadow: none;
  }

  input,
  .MuiSelect-select {
    ${inputTextCss};
  }
`
